import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { theme } from "config/theme";
import { COLORS } from "constants/colors";

export interface StyleProps {
  buttonName?: string;
}

export const todoStyle = makeStyles(() =>createStyles({
  container: { 
    marginLeft: "0.4rem", 
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
  },
}));

export const actionStyles = makeStyles<Theme, StyleProps>({
  paper: {
    backgroundColor: "transparent",
  },
  button: {
    backgroundColor: COLORS.orange,
    "&:hover": {
      backgroundColor: COLORS.orange,
      boxShadow: "none",
    },
    buttonGroup: {
      backgroundColor: `${COLORS.orange}!important`,
      boxShadow: "none",
      [theme.breakpoints.down("xs")]: { left: "40px", position: "relative", top: -33 },
      "& .MuiButtonGroup-contained": {
        boxShadow: "none",
      },
    },
    label: {
      width: "150px",
    },
  },
  buttonGroup: {
    boxShadow: "none",
    [theme.breakpoints.down("xs")]: { left: "52px", position: "relative", top: -33 },
    "&:hover": {
      boxShadow: "none",
    },
  },
  label: {
    width: "150px",
  },
  menuList: {
    boxShadow: "0 4px 10px 0 rgba(0, 0, 0, 0.1)",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
    width: "210px",
    marginLeft: -4,
    backgroundColor: "#fff",
    [theme.breakpoints.down("xs")]: {
      background: "white",
    },
  },
  buttonName: {
    backgroundColor: "#f2994a",
    fontSize: "13px",
    width: "210px",
    "& .MuiButton-label": {
      justifyContent: ({ buttonName }) => `${buttonName === "add parcel" ? "flex-start" : ""}`,
    },
    "&:hover": { background: "#f2994a", boxShadow: "none" },
  },
});
